module.exports = __webpack_public_path__ + "img/mandarine_1333.eabf0b63.jpg";